<template>
    <el-container style=" border: 1px solid #eee;width: 500px;">	
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <i class="el-icon-circle-plus" style="color: #2289e9;"></i>
                    <span style="margin-left: 10px;">用户注册</span>
                  </div>
                 <div style="width: 100%;color:#7900cf" >
                     <el-form :model="form":rules="rules" ref="Form" label-width="80px">
                         <el-form-item prop="username" label="用户名">
                             <el-input v-model="form.username"  prefix-icon="el-icon-user" placeholder="请输入用户名"></el-input>
                         </el-form-item>
                         <el-form-item prop="password" label="密码">
                             <el-input v-model="form.password" type="password" prefix-icon="el-icon-lock"  placeholder="请输入密码"></el-input>
                         </el-form-item>
                        <el-form-item prop="confirmPwd" label="确认密码">
                            <el-input v-model="form.confirmPwd" type="password" prefix-icon="el-icon-lock" placeholder="请再次输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="用户类型" prop="type">
                            <el-select v-model="form.type" placeholder="请选择用户类型">
                            <el-option label="超级管理员" value="admin"></el-option>
                            <el-option label="普通用户" value="user"></el-option>
                            </el-select>
                        </el-form-item>
                    <el-form-item class="btn-box"  style="width: 500px;">
                      <el-button type="primary" @click="onSubmit('Form')" style="width: 44%;background-color: #2289e9;border: none;">注册</el-button>
                      <el-button @click="resetForm('Form')" style="width: 43%;">重置</el-button>
                    </el-form-item>
                     </el-form>	
                 </div>
                </el-card>
    </el-container>
    </template>
    <script>
      export default {
        data() {
            var validatePass = (rule, value, callback) => {
               if (value==='') {
                 callback(new Error('请再次输入密码'));f
               } else if (value !== this.form.password) {
                 callback(new Error('两次输入密码不一致!'));
               } else {
                 callback();
               }
             };
          return {
              ChatUser: {
                username: '',
                password: '',
                limits:'',
                creatTime:''
              },
            form: {
              username:"",
              password:"",
              confirmPwd:"",
              type:""
            },
            rules: {
              username: [
                { required: true, message: '请输入账号', trigger: 'blur' },
                { min: 6, max: 20, message: '长度在 6到 12 个字符', trigger: 'blur' }
              ],
              password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
                { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' },
              ],
              type: [
             { required: true, message: '请选择用户类型', trigger: 'change' }
           ],
              confirmPwd:[
                  { validator: validatePass, trigger: 'blur', required: true }
             ],
             
             
            }
          }
        },
        methods: {
            
          onSubmit(formName) {
           this.$refs[formName].validate((valid) => {
             if (valid){
                const timestamp = new Date().getTime();
                  const date = new Date(timestamp);
                  this.ChatUser.creatTime= date.toLocaleString();
                  if(this.form.type=="admin"){
                    this.ChatUser.limits="1"
                  }
                  if(this.form.type=="user"){
                    this.ChatUser.limits="0"
                  }
                this.ChatUser.username=this.form.username;
                this.ChatUser.password=this.form.password;
                this.request.post("/userRegister", this.ChatUser).then(res => {
                  if(res.code=='0'){
                        this.$message({message: '注册成功',type: 'success'});
                        this.$router.push('/home/Welcome');
                       
                   }else{
                        this.$message.error(res.msg);
                  }
                })
             }else {
               console.log('error submit!!')
               return false
             }
           })
          },
          resetForm (formName) {
              this.$refs[formName].resetFields();
          }
        }
      }
    </script>